import type { TNamespace } from '@/config/types';
import type { INamespaceContent } from './types';
import { getContent as getIngleContent } from './namespaces/ingle';
import { getContent as getTisContent } from './namespaces/tis';

export type {
  INamespaceContent,
  IService,
  IFAQQuestion,
  IFAQDocument,
  IClaimsContent,
} from './types';

const namespace = import.meta.env.VITE_NAMESPACE as TNamespace;

const contentRegistry: Record<TNamespace, () => INamespaceContent> = {
  ingle: getIngleContent,
  tis: getTisContent,
};

export const getActiveContent = (): INamespaceContent =>
  contentRegistry[namespace]();

export function useActiveContent(): INamespaceContent {
  return getActiveContent();
}
